import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Layout } from "../pages/landing/Layout";
import { Loader } from "../components/Loader";
import { SellFaq } from "../sections/SellFaq";
import { CallToAction } from "../sections/CallToAction";
import { OutlineMakerHow } from "../sections/outline_maker/OutlineMakerHow";
import { PatternDiscover } from "../sections/pattern/PatternDiscover";
import { OutlineMakerBanner } from "../sections/outline_maker/OutlineMakerBanner";
import { FeatureImageRight } from "../sections/FeatureImageRight";
import { FeatureImageLeft } from "../sections/FeatureImageLeft";
import { FeatureImageCfLeft } from "../sections/FeatureImageCfLeft";
import { FeatureImageCfRight } from "../sections/FeatureImageCfRight";

export const outline_maker_faq_data = [
    {
        question: "How can I outline images using the Outline Maker?",
        answer: "All you have to do is upload your image, select your desired outline style and colors, and it's done.",
    },
    {
        question: "Can I Change the Color of The Picture Outline?",
        answer: "Yes, you can customize the outline colors and background color to match you style or needs.",
    },
    {
        question:
            "Do I need to use the Background Remover before getting outlines of images?",
        answer: "No, it is not necessary, the outline maker can work on images with or without background.",
    },
    {
        question: "What about privacy? Are my headshot photos safe?",
        answer: "Yes, your images are safe with us. Patternful.ai prioritizes user data safety. Your images are always private, proprietary, and they remain your property. All your uploaded images are automatically deleted from our servers after a few hours.",
    },
];

class OutlineMakerLanding extends Component {
    constructor(props) {
        super(props);
        this.state = { isLoading: true };
    }
    componentDidMount() {
        this.setState({ isLoading: false });
    }

    render() {
        if (this.state.isLoading) {
            return <Loader />;
        }
        return (
            <Layout>
                <Helmet>
                    <title>Outline Maker</title>
                    <meta
                        name="description"
                        content="Generate professional outlines in various styles."
                    />
                    <meta
                        name="keywords"
                        content="Outline Maker, AI Outline Maker, Outline Maker APP, Outline Online Maker, Image Processing, AI Image Editing, Patternful, Patternful AI"
                    />
                </Helmet>
                <OutlineMakerBanner />
                <OutlineMakerHow />
                <FeatureImageCfLeft
                    beforeImage={"/images/outline/2.webp"}
                    afterImage={"/images/outline/2_generated.webp"}
                    title={"Enhance Your Product Image with a Neat Outline"}
                    description={
                        "A clean, solid outline around your product photos instantly catches the eye, drawing attention to your items and giving your presentation a more polished, professional look. Whether you're an online seller or creating banners, a slightly thick border in a solid color can make your products stand out and attract potential buyers. This simple yet powerful detail can elevate your images on e-commerce platforms and social media, helping your products pop and giving you an edge over competitors."
                    }
                />
                <FeatureImageCfRight
                    beforeImage={"/images/outline/3.webp"}
                    afterImage={"/images/outline/3_generated.webp"}
                    title={
                        "Make Your Portrait Look Beautiful with a Defined Outline"
                    }
                    description={
                        "Add an outline to your portrait images for a cleaner, more creative look that transforms plain photos into eye-catching works of art. With our outline maker, it's easy to apply outlines to faces or clothing, giving your portraits a distinctive and polished touch. Whether for personal use, social media, or professional projects, this simple enhancement helps your images stand out with a unique, artistic feel that sets them apart from ordinary photos."
                    }
                />
                <FeatureImageCfLeft
                    beforeImage={"/images/outline/4.webp"}
                    afterImage={"/images/outline/4_generated.webp"}
                    title={
                        "Post Your Pictures with a Unique Outline on Various Social Media Platform"
                    }
                    description={
                        "Easily share your newly outlined images on social media and make your photos stand out with a bold, creative touch. Creating outlined images takes just a few clicks—no editing skills or professional tools needed, as AI handles the process for you. Whether you're sharing with friends or promoting a business, outlined photos are visually striking and instantly grab attention, giving your posts a polished, professional edge across all your favorite platforms."
                    }
                />
                <CallToAction
                    title={"Ready to Make Your Photos Stand Out"}
                    subtitle={
                        "Add bold, creative outlines to your images and watch them transform into eye-catching visuals that grab attention instantly. No design skills needed — just upload, outline, and share!"
                    }
                    link={"/outline-maker/app"}
                    cta={"Try It Now"}
                />
                <SellFaq data={outline_maker_faq_data} />
                <PatternDiscover />
            </Layout>
        );
    }
}

function mapStateToProps(state) {
    return { userAccount: state.authReducer?.userAuth.userAccount };
}

export default connect(mapStateToProps, {})(withRouter(OutlineMakerLanding));
